/**
 * Hero Sales Display
 * Displays sales value on SVG placeholder above hero buttons
 */

console.log('[Hero Sales] ========== SCRIPT FILE LOADED ==========');
console.log('[Hero Sales] Timestamp:', new Date().toISOString());

(function() {
  'use strict';

  console.log('[Hero Sales] IIFE executing...');
  console.log('[Hero Sales] Document ready state:', document.readyState);

  /**
   * Extract money value from string
   */
  function extractMoneyValue(moneyString) {
    if (!moneyString) return 0;
    const cleanedString = moneyString.replace(/[$,]/g, '');
    return parseFloat(cleanedString) || 0;
  }

  /**
   * Format currency (rounded to whole dollars)
   */
  function formatCurrency(value) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(Math.round(value));
  }

  /**
   * Get sales value from the countup widget
   */
  function getSalesValue() {
    console.log('[Hero Sales] Starting getSalesValue()...');
    
    // First, let's see what elements are actually on the page
    console.log('[Hero Sales] Searching for sales-related elements...');
    const allDivs = document.querySelectorAll('div[id*="sales"], div[class*="sales"], div[id*="countup"], div[class*="countup"]');
    console.log('[Hero Sales] Found', allDivs.length, 'elements with "sales" or "countup" in id/class');
    allDivs.forEach((div, index) => {
      console.log(`[Hero Sales]   ${index + 1}. ID: "${div.id}", Class: "${div.className}"`);
    });
    
    // Check for the specific element
    const moneyElements = document.querySelectorAll('.els-cup-w-val, .els-cup-w-val--money, [class*="els-cup"]');
    console.log('[Hero Sales] Found', moneyElements.length, 'elements with "els-cup" class');
    moneyElements.forEach((el, index) => {
      console.log(`[Hero Sales]   ${index + 1}. Class: "${el.className}", Text: "${el.textContent?.trim()?.substring(0, 50)}"`);
    });
    
    return new Promise((resolve) => {
      let attempts = 0;
      const maxAttempts = 50;
      let lastValue = 0;
      let stableCount = 0;
      const requiredStableChecks = 3;

      const checkInterval = setInterval(() => {
        attempts++;

        if (attempts === 1 || attempts % 10 === 0) {
          console.log('[Hero Sales] Attempt:', attempts, '/ Max:', maxAttempts);
        }

        const moneyElement = document.querySelector('.els-cup-w-val--money');

        if (moneyElement) {
          const moneyText = moneyElement.textContent.trim();
          const value = extractMoneyValue(moneyText);

          if (attempts === 1) {
            console.log('[Hero Sales] Found .els-cup-w-val--money element');
            console.log('[Hero Sales] Raw text:', moneyText);
            console.log('[Hero Sales] Extracted value:', value);
          }

          if (value > 0 && (moneyText.includes('$') || moneyText.includes(','))) {
            if (value === lastValue) {
              stableCount++;
              console.log('[Hero Sales] Value stable count:', stableCount, '/', requiredStableChecks);

              if (stableCount >= requiredStableChecks) {
                console.log('[Hero Sales] ✓ Found stable value:', moneyText);
                console.log('[Hero Sales] ✓ Final extracted value:', value);
                clearInterval(checkInterval);
                resolve(value);
                return;
              }
            } else {
              stableCount = 0;
              lastValue = value;
              console.log('[Hero Sales] Value changed to:', value, '- resetting stability counter');
            }
          }
        } else if (attempts === 1 || attempts % 10 === 0) {
          console.log('[Hero Sales] ⚠ .els-cup-w-val--money element not found');
        }

        if (attempts >= maxAttempts) {
          clearInterval(checkInterval);
          console.log('[Hero Sales] ⚠ Max attempts reached, last value:', lastValue);
          resolve(lastValue);
        }
      }, 200);
    });
  }

  /**
   * Animate loading dots
   */
  function startLoadingAnimation(elements) {
    const dots = ['.', '..', '...'];
    let currentIndex = 0;
    
    const interval = setInterval(() => {
      elements.forEach(element => {
        element.textContent = dots[currentIndex];
      });
      currentIndex = (currentIndex + 1) % dots.length;
    }, 500); // Change every 500ms
    
    return interval;
  }

  /**
   * Update the sales display with the value
   */
  async function updateSalesDisplay() {
    console.log('[Hero Sales] ===== updateSalesDisplay() called =====');
    console.log('[Hero Sales] Current time:', new Date().toISOString());
    
    // Find ALL sales display value elements (there may be multiple hero slides)
    const valueElements = document.querySelectorAll('#hero-sales-value');
    
    console.log('[Hero Sales] Looking for elements...');
    console.log('[Hero Sales] Found', valueElements.length, 'hero-sales-value elements');
    
    if (valueElements.length === 0) {
      console.log('[Hero Sales] ❌ No sales display elements found in DOM');
      return;
    }

    console.log('[Hero Sales] ✓ Found', valueElements.length, 'sales display elements');

    // Start loading animation
    const loadingInterval = startLoadingAnimation(valueElements);

    // Get sales value
    console.log('[Hero Sales] Fetching sales value...');
    const salesValue = await getSalesValue();
    
    // Stop loading animation
    clearInterval(loadingInterval);
    
    console.log('[Hero Sales] getSalesValue() returned:', salesValue);
    
    if (salesValue === 0) {
      console.log('[Hero Sales] ❌ No sales value found (returned 0)');
      console.log('[Hero Sales] Keeping default $0 in all displays');
      return;
    }

    console.log('[Hero Sales] ✓ Sales value retrieved:', salesValue);
    
    // Calculate 15% of the sales value
    const calculatedValue = salesValue * 0.15;
    console.log('[Hero Sales] ✓ Calculated 15% of', salesValue, '=', calculatedValue);
    
    const formattedValue = formatCurrency(calculatedValue);
    console.log('[Hero Sales] ✓ Formatted value:', formattedValue);

    // Update ALL value elements
    console.log('[Hero Sales] Updating', valueElements.length, 'DOM elements...');
    valueElements.forEach((element, index) => {
      element.textContent = formattedValue;
      console.log('[Hero Sales] Updated element', index + 1, 'to:', formattedValue);
    });
    console.log('[Hero Sales] ✓ All values updated in DOM');

    // Hide original sales countup block
    const salesBlocks = document.querySelectorAll('[id*="sales_countup_section_block"]');
    console.log('[Hero Sales] Hiding', salesBlocks.length, 'original sales blocks');
    salesBlocks.forEach((block, index) => {
      block.style.display = 'none';
      console.log('[Hero Sales] Hidden block', index + 1, ':', block.id);
    });
    
    console.log('[Hero Sales] ===== COMPLETE =====');
  }

  // Initialize when DOM is ready
  console.log('[Hero Sales] Setting up initialization...');
  if (document.readyState === 'loading') {
    console.log('[Hero Sales] Document still loading, adding DOMContentLoaded listener');
    document.addEventListener('DOMContentLoaded', function() {
      console.log('[Hero Sales] DOMContentLoaded event fired');
      updateSalesDisplay();
    });
  } else {
    console.log('[Hero Sales] Document already loaded, executing immediately');
    updateSalesDisplay();
  }

})();

console.log('[Hero Sales] ========== SCRIPT INITIALIZATION COMPLETE ==========');
